/* Lunéa — tema etkileşimleri. Framework yok; native web components + fetch. */
(function () {
  'use strict';

  var html = document.documentElement;
  var theme = window.theme || { routes: {}, strings: {} };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Yardımcılar ---------- */
  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function announce(message) {
    var el = document.getElementById('A11yAnnouncer');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = message; }, 50);
  }
  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- Çekmeceler (menü, sepet) ---------- */
  var Drawer = {
    active: null,
    trigger: null,
    open: function (el, trigger) {
      if (!el) return;
      if (this.active && this.active !== el) this.close(this.active, true);
      this.active = el;
      this.trigger = trigger || document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      html.classList.add('scroll-lock');
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var panel = el.querySelector('.drawer__panel');
      requestAnimationFrame(function () { if (panel) panel.focus(); });
    },
    close: function (el, silent) {
      el = el || this.active;
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      html.classList.remove('scroll-lock');
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (!silent && this.trigger && document.body.contains(this.trigger)) this.trigger.focus();
      this.active = null;
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      Drawer.open(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer && closer.closest('[data-drawer]')) {
      e.preventDefault();
      Drawer.close(closer.closest('[data-drawer]'));
      return;
    }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && document.getElementById('CartDrawer') && theme.cartType === 'drawer') {
      e.preventDefault();
      Drawer.open(document.getElementById('CartDrawer'), cartToggle);
      return;
    }
    // Arama panelini dışarı tıklayınca kapat
    document.querySelectorAll('.header__search[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Drawer.active) { Drawer.close(); return; }
      document.querySelectorAll('.header__search[open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    }
    if (e.key === 'Tab' && Drawer.active) {
      var panel = Drawer.active.querySelector('.drawer__panel');
      var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.classList && d.classList.contains('header__search') && d.open) {
      var input = d.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
  }, true);

  /* ---------- Header ---------- */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.header-wrapper') || this.parentElement;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.last = window.scrollY;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        var y = window.scrollY;
        this.wrapper.classList.toggle('is-scrolled', y > 40);
        var canHide = this.hideOnScroll && window.innerWidth < 1024 && !html.classList.contains('scroll-lock') && !this.querySelector('.header__search[open]');
        if (canHide) {
          if (y > this.last + 4 && y > 240) this.wrapper.classList.add('is-hidden');
          else if (y < this.last - 4) this.wrapper.classList.remove('is-hidden');
        } else {
          this.wrapper.classList.remove('is-hidden');
        }
        this.last = y;
        this.ticking = false;
      });
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* ---------- Sepet ---------- */
  var Cart = {
    sectionIds: function () {
      var ids = ['cart-count'];
      if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
      var page = document.querySelector('cart-items');
      if (page && page.dataset.section) ids.push(page.dataset.section);
      return ids;
    },
    render: function (sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        var doc = parseHTML(sections['cart-drawer']);
        var next = doc.getElementById('CartDrawerInner');
        var current = document.getElementById('CartDrawerInner');
        if (next && current) current.replaceWith(next);
      }
      if (sections['cart-count']) {
        var bubble = document.getElementById('CartCountBubble');
        var countDoc = parseHTML(sections['cart-count']);
        var wrapper = countDoc.querySelector('.shopify-section');
        if (bubble) bubble.innerHTML = wrapper ? wrapper.innerHTML : '';
      }
      var page = document.querySelector('cart-items');
      if (page && sections[page.dataset.section]) {
        var pageDoc = parseHTML(sections[page.dataset.section]);
        var nextItems = pageDoc.querySelector('cart-items');
        if (!nextItems) { window.location.reload(); return; }
        page.innerHTML = nextItems.innerHTML;
      }
    },
    open: function (showNotice) {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) { window.location.href = theme.routes.cart; return; }
      if (showNotice) {
        var notice = drawer.querySelector('[data-cart-notice]');
        if (notice) notice.hidden = false;
      }
      Drawer.open(drawer, document.activeElement);
    },
    change: function (line, quantity, scope) {
      var list = scope && scope.querySelector('.cart-items');
      if (list) list.classList.add('is-loading');
      var focusLine = line;
      return fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || theme.strings.cartError);
          Cart.render(r.data.sections);
          var input = document.querySelector('[data-cart-input][data-line="' + focusLine + '"]');
          if (input && scope && scope.contains(input)) input.focus();
          announce(r.data.item_count > 0 ? 'Sepet güncellendi.' : 'Sepetin boş.');
        })
        .catch(function (err) { announce(err.message || theme.strings.cartError); })
        .finally(function () { if (list) list.classList.remove('is-loading'); });
    },
    updateNote: debounce(function (note) {
      fetch(theme.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note })
      });
    }, 500)
  };

  function bindCartEvents(el) {
    el.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        Cart.change(qtyBtn.dataset.line, Math.max(0, parseInt(qtyBtn.dataset.cartQty, 10) || 0), el);
        return;
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        Cart.change(remove.dataset.line, 0, el);
      }
    });
    el.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-input]');
      if (input) Cart.change(input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0), el);
    });
    el.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (note) Cart.updateNote(note.value);
    });
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() { bindCartEvents(this); }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  class CartItems extends HTMLElement {
    connectedCallback() { bindCartEvents(this); }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  /* ---------- Ürün formu ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.querySelector('[data-add-button]');
      this.label = this.querySelector('[data-add-label]');
      this.error = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', (e) => {
        var step = e.target.closest('[data-qty-step]');
        if (!step) return;
        var input = this.querySelector('.qty__input');
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
        input.value = Math.max(1, next);
      });
      this.picker = this.querySelector('[data-variant-picker]');
      if (this.picker) this.picker.addEventListener('change', this.onVariantChange.bind(this));
    }
    setBusy(busy) {
      if (!this.button) return;
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (!this.label) return;
      if (busy) {
        this.originalLabel = this.label.textContent;
        this.label.textContent = theme.strings.adding || 'Ekleniyor…';
      } else if (this.originalLabel) {
        this.label.textContent = this.originalLabel;
      }
    }
    onSubmit(e) {
      e.preventDefault();
      if (!this.button || this.button.disabled || this.button.getAttribute('aria-busy') === 'true') return;
      if (theme.cartType !== 'drawer' || !document.getElementById('CartDrawer')) {
        this.form.submit();
        return;
      }
      this.setBusy(true);
      if (this.error) this.error.hidden = true;
      var fd = new FormData(this.form);
      fd.append('sections', Cart.sectionIds().join(','));
      fd.append('sections_url', window.location.pathname);
      fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then((r) => {
          if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || theme.strings.cartError);
          Cart.render(r.data.sections);
          Cart.open(true);
          announce(theme.strings.addedToCart || 'Ürün sepetine eklendi.');
        })
        .catch((err) => {
          if (this.error) {
            this.error.textContent = err.message || theme.strings.cartError;
            this.error.hidden = false;
          }
        })
        .finally(() => this.setBusy(false));
    }
    onVariantChange() {
      var json = this.picker.querySelector('[data-variants-json]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var selected = Array.prototype.map.call(this.picker.querySelectorAll('fieldset'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var input = this.form.querySelector('[data-variant-input]');
      if (!variant) {
        this.button.disabled = true;
        if (this.label) this.label.textContent = theme.strings.unavailable || 'Mevcut değil';
        return;
      }
      input.value = variant.id;
      this.button.disabled = !variant.available;
      if (this.label) this.label.textContent = variant.available ? (theme.strings.addToCart || 'Sepete Ekle') : (theme.strings.soldOut || 'Tükendi');
      var scope = this.closest('.product-section, .featured, .final-cta') || document;
      var price = scope.querySelector('[data-price]');
      if (price) price.textContent = formatMoney(variant.price);
      var compare = scope.querySelector('[data-compare-price]');
      if (compare && variant.compare_at_price) compare.textContent = formatMoney(variant.compare_at_price);
      if (this.closest('.product-section')) {
        window.history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---------- Galeri ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.current = this.querySelector('[data-gallery-current]');
      this.dialog = this.querySelector('[data-lightbox]');
      this.track.addEventListener('scroll', debounce(() => this.update(), 60), { passive: true });
      var prev = this.querySelector('[data-gallery-prev]');
      var next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.go(-1));
      if (next) next.addEventListener('click', () => this.go(1));
      this.addEventListener('click', (e) => {
        var zoom = e.target.closest('[data-zoom]');
        if (zoom && this.dialog && typeof this.dialog.showModal === 'function') this.openLightbox(parseInt(zoom.dataset.zoom, 10));
      });
      if (this.dialog) {
        var close = this.dialog.querySelector('[data-lightbox-close]');
        if (close) close.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          html.classList.remove('scroll-lock');
          if (this.lastZoom) this.lastZoom.focus();
        });
      }
    }
    index() {
      return Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
    }
    update() {
      if (this.current) this.current.textContent = Math.min(this.slides.length, this.index() + 1);
    }
    go(delta) {
      var i = Math.max(0, Math.min(this.slides.length - 1, this.index() + delta));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }
    openLightbox(i) {
      this.lastZoom = document.activeElement;
      this.dialog.showModal();
      html.classList.add('scroll-lock');
      var item = this.dialog.querySelector('[data-lightbox-index="' + i + '"]');
      if (item) item.scrollIntoView({ block: 'start' });
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);

  /* ---------- Sabit Sepete Ekle çubuğu (mobil) ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      var form = document.getElementById(this.dataset.target);
      var button = form && form.querySelector('[data-add-button]');
      if (!button || !('IntersectionObserver' in window)) return;
      this.buttonVisible = true;
      this.footerVisible = false;
      var footer = document.querySelector('.footer');
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === button) this.buttonVisible = entry.isIntersecting;
          else this.footerVisible = entry.isIntersecting;
        });
        this.toggle();
      });
      this.observer.observe(button);
      if (footer) this.observer.observe(footer);
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    toggle() {
      var show = !this.buttonVisible && !this.footerVisible;
      this.classList.toggle('is-visible', show);
      this.inert = !show;
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* ---------- Fırçalarla Tanış ---------- */
  class BrushExplorer extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));
      this.tablist = this.querySelector('[role="tablist"]');
      this.stage = this.querySelector('.brushes__stage');
      if (!this.tabs.length) return;
      this.index = 0;
      this.tablist.classList.add('has-selection');
      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i)));
      this.tablist.addEventListener('keydown', (e) => this.onKey(e));
      this.querySelectorAll('[data-brush-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.querySelectorAll('[data-brush-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));
      this.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => this.filter(b)));
      this.updateCount();
    }
    visible() { return this.tabs.filter(function (t) { return !t.hidden; }); }
    select(i, focus) {
      this.index = i;
      this.tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      var tab = this.tabs[i];
      if (focus) tab.focus({ preventScroll: true });
      if (this.stage && this.stage.scrollWidth > this.stage.clientWidth + 2) {
        var left = tab.offsetLeft - this.stage.clientWidth / 2 + tab.offsetWidth / 2;
        this.stage.scrollTo({ left: left, behavior: 'smooth' });
      }
      this.updateCount();
    }
    step(delta, focus) {
      var vis = this.visible();
      if (!vis.length) return;
      var pos = vis.indexOf(this.tabs[this.index]);
      var next = vis[(pos + delta + vis.length) % vis.length];
      this.select(this.tabs.indexOf(next), focus);
    }
    onKey(e) {
      var map = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      var vis = this.visible();
      if (e.key in map) { e.preventDefault(); this.step(map[e.key], true); }
      else if (e.key === 'Home') { e.preventDefault(); this.select(this.tabs.indexOf(vis[0]), true); }
      else if (e.key === 'End') { e.preventDefault(); this.select(this.tabs.indexOf(vis[vis.length - 1]), true); }
    }
    filter(button) {
      var zone = button.dataset.filter;
      this.querySelectorAll('[data-filter]').forEach(function (b) {
        var on = b === button;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.tabs.forEach(function (t) { t.hidden = zone !== 'all' && t.dataset.zone !== zone; });
      if (this.tabs[this.index].hidden) {
        var first = this.visible()[0];
        if (first) this.select(this.tabs.indexOf(first));
      } else {
        this.updateCount();
      }
    }
    updateCount() {
      var vis = this.visible();
      var pos = vis.indexOf(this.tabs[this.index]) + 1;
      var panel = this.panels[this.index];
      var count = panel && panel.querySelector('.brushes__count');
      if (count) count.textContent = pos + ' / ' + vis.length;
    }
  }
  if (!customElements.get('brush-explorer')) customElements.define('brush-explorer', BrushExplorer);

  /* ---------- Ürün önerileri ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.product-grid') || !this.dataset.url || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        fetch(this.dataset.url)
          .then(function (r) { return r.text(); })
          .then((text) => {
            var inner = parseHTML(text).querySelector('product-recommendations');
            if (inner && inner.querySelector('.product-grid')) this.innerHTML = inner.innerHTML;
          })
          .catch(function () {});
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Kaydırma animasyonları ---------- */
  function initReveal() {
    if (designMode || !html.classList.contains('has-anim') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    html.classList.add('reveal-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal);
  else initReveal();

  /* Theme Editor: yeniden yüklenen bölümlerde çekmeceyi kapat */
  document.addEventListener('shopify:section:load', function () {
    if (Drawer.active) Drawer.close(null, true);
  });
})();
